import {
  Target,
  Wrench,
  Handshake,
  BadgeCheck,
  CarFront,
  ThumbsUp,
} from "lucide-react";

const reasons = [
  {
    icon: Target,
    title: "تشخيص دقيق",
    desc: "معدّات حديثة وخبرة عملية لتحديد العطل الحقيقي من أول فحص، بدون تخمين.",
  },
  {
    icon: Wrench,
    title: "خبرة عملية",
    desc: "سنوات من العمل على آلاف السيارات ومختلف الموديلات — نعرف مكامن الأعطال.",
  },
  {
    icon: Handshake,
    title: "تعامل محترم",
    desc: "أسلوب مهني، وضوح في الشرح، وتقدير لوقت العميل من أول زيارة.",
  },
  {
    icon: BadgeCheck,
    title: "مصداقية في تحديد العطل",
    desc: "نوضّح السبب الحقيقي قبل أي إصلاح، ولا نُبدّل قطعة سليمة.",
  },
  {
    icon: CarFront,
    title: "خدمة لجميع السيارات",
    desc: "يابانية، أمريكية، أوروبية، كورية — قديم وحديث، لدينا الخبرة المناسبة.",
  },
  {
    icon: ThumbsUp,
    title: "رضا العملاء دليل الجودة",
    desc: "تقييم 4.7/5 و +474 مراجعة حقيقية تشهد على جودة الشغل والأمانة.",
  },
];

export const WhyUs = () => {
  return (
    <section
      id="why"
      data-testid="why-us-section"
      className="relative py-20 lg:py-28"
    >
      <div className="absolute inset-0 -z-10 radial-glow" />

      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="text-center max-w-3xl mx-auto mb-14 reveal">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-cyan-400 font-semibold mb-4">
            <span className="w-8 h-px bg-cyan-400" />
            لماذا نحن
            <span className="w-8 h-px bg-cyan-400" />
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
            الأسباب اللي تخلّي العملاء يرجعون لنا
          </h2>
          <p className="mt-5 text-lg text-slate-400 leading-relaxed">
            تخصص، أمانة، وشغل واضح. هذه الأسس اللي بنينا عليها اسمنا في الرياض.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {reasons.map((r, i) => {
            const Icon = r.icon;
            return (
              <div
                key={i}
                data-testid={`why-us-card-${i}`}
                className="reveal relative rounded-2xl p-6 lg:p-7 border border-slate-800 bg-slate-900/50 hover:border-cyan-500/30 hover:bg-slate-900/80 transition-all duration-300 group"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-slate-950 border border-slate-800 flex items-center justify-center flex-shrink-0 group-hover:border-cyan-500/40 transition-colors">
                    <Icon className="w-6 h-6 text-cyan-400" />
                  </div>
                  <div>
                    <h3 className="text-lg lg:text-xl font-bold text-white">
                      {r.title}
                    </h3>
                    <p className="mt-2 text-sm lg:text-base text-slate-400 leading-relaxed">
                      {r.desc}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
